import React, { useMemo } from "react";
import { useOffersUIContext } from "../OffersUIContext";

export function OffersGrouping() {
  // Offers UI Context
  const offersUIContext = useOffersUIContext();
  const offersUIProps = useMemo(() => {
    return {
      ids: offersUIContext.ids,
      setIds: offersUIContext.setIds,
      openDeleteOffersDialog: offersUIContext.openDeleteOffersDialog,
      openFetchOffersDialog: offersUIContext.openFetchOffersDialog,
      openUpdateOffersStatusDialog:
        offersUIContext.openUpdateOffersStatusDialog,
    };
  }, [offersUIContext]);

  return (
    <div className="form">
      <div className="row align-items-center form-group-actions margin-top-20 margin-bottom-20">
        <div className="col-xl-12">
          <div className="form-group form-group-inline">
            <div className="form-label form-label-no-wrap">
              <label className="font-bold font-danger">
                <span>
                  Selected records count: <b>{offersUIProps.ids.length}</b>
                </span>
              </label>
            </div>
            <div>
              &nbsp;
              <button
                type="button"
                className="btn btn-light-primary font-weight-bolder font-size-sm"
                onClick={offersUIProps.openUpdateOffersStatusDialog}
              >
                <i className="fa fa-sync-alt"></i> Update Status
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
